import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
type PaginationProps = {
  page: number;
  pageCount: number;
  onChange: (page: number) => void;
};
export function Pagination({
  page,
  pageCount,
  onChange
}: PaginationProps) {
  if (pageCount <= 1) return null;
  const pages = Array.from({
    length: pageCount
  }, (_, i) => i + 1);
  const arrow = 'flex h-11 items-center gap-1.5 rounded-[7px] px-3 text-[15px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-canvas-warm disabled:pointer-events-none disabled:opacity-40';
  return <nav aria-label="Pagination" className="mt-14 flex items-center justify-center gap-1" data-id="element-153" data-mp="3tn6m8c4pvsnc">
      <button type="button" className={arrow} disabled={page === 1} onClick={() => onChange(page - 1)} data-id="element-154" data-mp="3orr77guz3qpc">
        <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-155" data-mp="3jt6fy6xp8hd1" />
        <span className="hidden sm:inline" data-id="element-156" data-mp="l6lgd47dtfog">Previous</span>
      </button>
      {pages.map(p => <button key={p} type="button" aria-current={p === page ? 'page' : undefined} aria-label={`Page ${p}`} onClick={() => onChange(p)} className={`h-11 w-11 rounded-[7px] text-[15px] font-semibold tabular-nums transition-colors duration-150 ease-out ${p === page ? 'bg-ink text-white' : 'text-ink hover:bg-canvas-warm'}`} data-id="element-157" data-mp="gcr42lu3w2ze">
          {p}
        </button>)}
      <button type="button" className={arrow} disabled={page === pageCount} onClick={() => onChange(page + 1)} data-id="element-158" data-mp="1jbzmriu3xdez">
        <span className="hidden sm:inline" data-id="element-159" data-mp="1necq60ldsz8l">Next</span>
        <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-160" data-mp="1nbrp3dswqnbw" />
      </button>
    </nav>;
}